import React, { useEffect, useRef, useState } from 'react';
import { Image, Stack } from 'react-bootstrap';
import { IMAGE_PATHS } from 'constants/imagePaths';
import PostPhotoGallery from 'components/PostPhotoGallery';
import { S3_URL, USER_TYPES } from 'constants';
import { getCreatedDifferenceInBestUnit } from 'utils';
import useAuthStore from 'store/auth';
import { useNavigate } from 'react-router-dom';
import RenderMentions from 'components/SocialPost/RenderMentions';
import './styles.scss';
import useTranslate from 'hooks/useTranslate';

const RecentSocialPost: React.FC<any> = ({ post }) => {
	const navigate = useNavigate();
	const { translate } = useTranslate();
	const { user }: Record<string, any> = useAuthStore((state) => state.userInfo ?? {});

	const { id: postId, profilePicture, userId, userName, userType, activityType, createdAt } = post;

	const [hasMore, setHasMore] = useState(false);
	const descriptionRef = useRef(null);

	useEffect(() => {
		const element: any = descriptionRef?.current;
		if (element?.scrollHeight > element?.clientHeight) {
			setHasMore(true);
		}
	}, [post?.content]);

	const redirectToProfile = () => {
		navigate(`/${userType === USER_TYPES?.COMPANY ? 'company' : 'seeker'}/profile/${userId}`);
	};

	return (
		<div className="social-post mb-0">
			<Stack className="social-post-inner recent-activity">
				<div className="social-post-header position-relative d-flex justify-content-between align-items-center">
					<div className="post-profile d-flex align-items-md-center gap-2 gap-xxl-3">
						<div className="post-profile-img rounded-circle" onClick={() => redirectToProfile()}>
							<Image
								src={
									profilePicture?.length !== 0
										? `${S3_URL}${profilePicture}`
										: userType === USER_TYPES?.COMPANY
											? IMAGE_PATHS.CompanyLogoDefault
											: IMAGE_PATHS.UserDefault
								}
								className="w-100 h-100 object-fit-cover rounded-circle"
								loading="lazy"
							/>
						</div>
						<div className="">
							{userName && (
								<>
									<h5 onClick={() => redirectToProfile()} className="fw-bold mb-0 me-2">
										{user?.userId === userId ? translate('Profile.You') : userName}
									</h5>
									<span>
										{(() => {
											let type = '';
											switch (activityType) {
												case 'post':
													type = translate('Common.posted');
													break;
												case 'like':
													type = translate('Common.liked');
													break;
												case 'comment':
													type = translate('Common.commented');
													break;
												case 'share':
													type = translate('Common.shared');
													break;
												default:
													break;
											}
											return `${type} ${translate('Common.thisOn')} ${getCreatedDifferenceInBestUnit(createdAt)}`;
										})()}
									</span>
								</>
							)}
						</div>
					</div>
				</div>
				<div className="social-post-body">
					{post?.content && (
						<div className="post-content">
							<p
								className={`description-truncated ${hasMore ? 'has-more' : ''}`}
								ref={descriptionRef}
								onClick={() => navigate(`/feed-detail/${postId}`)}
							>
								<RenderMentions
									content={post?.content}
									taggedUsers={post?.taggedUsers}
									hashTags={post?.hashTags}
								/>
							</p>
						</div>
					)}
					{post?.mediaItems?.length > 0 && <PostPhotoGallery mediaItems={post?.mediaItems} />}
				</div>
			</Stack>
		</div>
	);
};

export default RecentSocialPost;
